<div [class.loader-hidden]="!show">
        <div class="loader-overlay">
                <div>
                        <mat-spinner style="left:50%;top:200px;" mode="indeterminate" *ngIf="show"></mat-spinner>
                </div>
        </div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/components/custom-loader/custom-loader.component.html